import uploadicon from "./upload_icon_24px.png";

export const UploadIcon = () => <img src={uploadicon} alt="Upload icon" />;
